export const SLK =
  "ZDA2NDBkZGMtNTQ0MS00MDMwLWI1Y2EtNWQ1N2NmNjA3NGZkOzE9MjAyNi0wMS0zMCwyPTIwMjYtMDEtMzAsND0yMDI2LTAxLTMw";
